module.exports = __webpack_public_path__ + "static/img/AI_target.b5f74295.svg";